import isFunction from 'lodash/isFunction';
import { request } from 'cn-request';
export function handleRequestService(requestConfig, remoteUrl) {
    const { service, searchKey = 'key', params: paramsProps, data: dataProps, searchFormat: searchFormatProps = (params) => params, formatParam, formatResult = (res) => {
        if (Array.isArray(res)) {
            return res;
        }
        else if (Array.isArray(res?.data)) {
            return res.data;
        }
        else if (Array.isArray(res?.data?.dataSource)) {
            return res.data.dataSource;
        }
        else if (Array.isArray(res?.data?.data)) {
            return res.data.data;
        }
        else if (Array.isArray(res?.data?.data?.dataSource)) {
            return res.data.data.dataSource;
        }
        return [];
    }, method = 'GET', } = requestConfig || {};
    // 配置了service时，promise由service托管
    if (isFunction(service)) {
        return async (searchConfig) => {
            return service(searchConfig)?.then((data) => {
                const dataSource = formatResult(data);
                return Array.isArray(dataSource) ? dataSource : [];
            });
        };
    }
    // 配置了remoteUrl，promise由cn-request执行
    if (remoteUrl) {
        return async (searchConfig) => {
            const searchFormat = formatParam ?? searchFormatProps;
            const params = method?.toLocaleUpperCase() === 'GET'
                ? searchFormat({ [searchKey]: searchConfig, ...paramsProps })
                : paramsProps;
            const data = method?.toLocaleUpperCase() === 'POST'
                ? searchFormat({ [searchKey]: searchConfig, ...dataProps })
                : dataProps;
            const resultData = await request({
                ...requestConfig,
                params,
                data,
                url: remoteUrl,
            });
            const dataSource = formatResult(resultData);
            return (Array.isArray(dataSource) ? dataSource : []);
        };
    }
    // 什么都没配置，返回一个空promise
    // eslint-disable-next-line
    return async (searchConfig) => {
        return [];
    };
}
